export default {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  getAlbumUUid: state => state.album_uuid,
  getSongId: state => state.song_id,
  getHistory:state => state.history,
  getUserPaymentStep: state => state.payment.payment_step,
  getUserPayment:state => state.payment,
  getUserPaymentProviders: state => state.payment_providers,
};
